export const AnimateFavorites = {
  mounted() {
    this.handleEvent("gems:animate-favorite", (data) => {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

      const { target } = data;
      if (target !== this.el.id) return;

      const sourceIcon = this.el.querySelector("svg") || this.el;
      if (!sourceIcon) return;

      const destIcon = document.getElementById("nav-favorites-icon");
      if (!destIcon) return;

      // Create clone
      const clone = sourceIcon.cloneNode(true);

      // Get positions
      const startRect = sourceIcon.getBoundingClientRect();
      const endRect = destIcon.getBoundingClientRect();

      // Style clone
      Object.assign(clone.style, {
        position: "fixed",
        top: `${startRect.top}px`,
        left: `${startRect.left}px`,
        width: `${startRect.width}px`,
        height: `${startRect.height}px`,
        zIndex: "9999",
        pointerEvents: "none",
        color: "#ef4444", // red-500
        transition:
          "top 1s cubic-bezier(0.2, 0.8, 0.2, 1), left 1s cubic-bezier(0.2, 0.8, 0.2, 1), transform 1s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.3s ease-in 0.5s",
        transformOrigin: "top left",
      });

      document.body.appendChild(clone);

      // Force reflow
      clone.getBoundingClientRect();

      // Calculate scale to match destination size
      const scale = endRect.width / startRect.width;

      // Animate
      requestAnimationFrame(() => {
        clone.style.top = `${endRect.top}px`;
        clone.style.left = `${endRect.left}px`;
        clone.style.transform = `scale(${scale})`;
        clone.style.opacity = "0";
      });

      // Cleanup;
      setTimeout(() => {
        clone.remove();
      }, 1100);
    });
  },
};
